import { render, staticRenderFns } from "./TagShowEdit.vue?vue&type=template&id=1226cb4f&lang=pug&"
import script from "./TagShowEdit.vue?vue&type=script&lang=js&"
export * from "./TagShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./TagShowEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TagShowEdit.vue"
export default component.exports